/**
 * 모두가 보는 기본 정보 — 퇴사하지 않은 사람의 이름 · 이메일 · 역할 · 재직 상태와 「모두에게 보임」인 직원 항목 값만.
 * 문서 폴더의 사람 열과 투입 인원 지정이 쓴다.
 */
import { HttpResponse, http } from "msw";
import { db } from "../db";
import { latency, requireUser } from "../http";

export const directoryHandlers = [
  http.get("/api/v1/users/", async () => {
    await latency();
    const user = requireUser();
    if (user instanceof Response) return user;
    return HttpResponse.json({
      results: db.users
        .filter((u) => u.status !== "resigned")
        .map(({ id, name, email, role, status, avatar_url, fields }) => ({
          id,
          name,
          email,
          role,
          status,
          avatar_url,
          fields: Object.fromEntries(
            Object.entries(fields).filter(
              ([fieldId]) => db.staffFields.find((field) => field.id === fieldId)?.is_public
            )
          ),
        })),
    });
  }),
];
